import { getArticleContentFromXML } from '../utilities/ArticleData';

export default class ArticleContent {
  article: Element;
  articleElements: HTMLElement[];
  tableOfContents: Element[];
  footnotes: Element[];

  constructor(
    article: Element,
    articleElements: HTMLElement[],
    tableOfContents: Element[],
    footnotes: Element[],
  ) {
    this.article = article;
    this.articleElements = articleElements;
    this.tableOfContents = tableOfContents;
    this.footnotes = footnotes;
  }

  public static fromXML(articleXML: string) {
    const content = getArticleContentFromXML(articleXML);

    const articleContent = new ArticleContent(
      content.article,
      content.articleElements,
      content.tableOfContents,
      content.footnotes,
    );

    return articleContent;
  }
}
